import axios from "../utils/axios-interceptor";

export const getSourceDatabase = async(payload) => {
  const res = await axios.post("/db_info", payload);
  const data = await res.data
  return data
}
//CompleteDB
export const getConvertMySQLDBToMongoDB = async(payload) => {
  const res = await axios.post("/convertMySQLDBToMongoDB", payload);
  const data = await res.data
  return data
}
//Selected tables
export const getConvertMySQLToMongoDB = async(payload) => {
  const res = await axios.post("/convertMySQLToMongoDB", payload);
  const data = await res.data
  return data
}